import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import PropTypes from 'prop-types';

import BaseBox from '../../internal/components/BaseBox';
import sx, { SxProp } from '../../internal/styles/sx';

const CheckboxLabel = styled(BaseBox, {
  shouldForwardProp,
})<SxProp>(
  css({
    lineHeight: 'checkbox',
    fontSize: 'checkbox',
    color: 'checkbox.labelColor',
  }),
  sx
);

CheckboxLabel.propTypes = {
  sx: PropTypes.object,
};

export default CheckboxLabel;
